import { defineMessages } from 'react-intl';

const translations = {
  yes: {
    id: 'properties.yes',
    defaultMessage: 'Yes',
    description: 'Label of the boolean value yes',
  },
  no: {
    id: 'properties.no',
    defaultMessage: 'No',
    description: 'Label of the boolean value no',
  },
  fields: {
    type: {
      label: {
        id: 'filter.type',
        defaultMessage: 'Type',
        description: 'Label of the type field of a filter',
      },
    },
    operator: {
      label: {
        id: 'filter.operator',
        defaultMessage: 'Operator',
        description: 'Label of the operator field of a filter',
      },
    },
    value: {
      label: {
        id: 'filter.value',
        defaultMessage: 'Value',
        description: 'Label of the value field of a filter',
      },
    },
  },
};

export default defineMessages(translations);
